import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {SnackbarService} from '../../../services/snackbar/snackbar.service';


@Component({
  selector: 'copy-to-clipboard',
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './copy-to-clipboard.component.html'
})
export class CopyToClipboardComponent {

  @Input() content: string | number | null | undefined;
  @Input() displayContent: boolean = true;
  @Input() tooltip: string = 'Click to copy';

  constructor(private snackbar: SnackbarService) {}

  copyToClipBoard(): void {
    if (!this.content) {
      return;
    }

    const content = String(this.content);

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(content).then(() => {
        this.snackbar.success('Copied! Now CTRL+V to paste this text wherever you need.', 1500);
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    } else {
      // Fallback (older browsers)
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = content;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }
      document.body.removeChild(selBox);

      this.snackbar.success('Copied! Now CTRL+V to paste this text wherever you need.', 1500);
    }
  }

}
